import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";

// The 'result' column is a TEXT field (max 65,535 bytes); this stays well under that even with multi-byte characters.
const REMARKS_MAX_LENGTH = 10000;

export const EditInspectionRemarksModal: FC<{
  inspection: Inspection;
  remarks: string | null;
  onFinished?: () => void;
}> = (props) => {
  const { updateInspectionRemarks } = useApiCall();
  const [remarks, setRemarks] = useState(props.remarks ?? "");
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    const trimmed = remarks.trim();
    await updateInspectionRemarks(props.inspection.id, trimmed === "" ? null : trimmed).catch(
      (e) => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat());
        }
        throw e;
      },
    );
    props.onFinished?.();
  };

  return (
    <div>
      <Input
        type={"textarea"}
        label={"Algemene opmerkingen"}
        value={remarks}
        onChange={setRemarks}
        maxWidth={"full"}
        minHeight={"500"}
        maxLength={REMARKS_MAX_LENGTH}
      />
      {errors.length > 0 && (
        <div className={"text-red-600 text-sm"}>
          {errors.map((e, i) => (
            <p key={i}>{e}</p>
          ))}
        </div>
      )}
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
